export const GA_CONFIG = {
  // Google Analytics 4 Measurement ID
  MEASUREMENT_ID: 'G-HVC169JZL3', // Your actual GA4 ID
  
  // Google Tag Manager ID
  GTM_ID: 'GT-MKB3RB8', // Your actual GTM ID
  
  // Analytics settings
  ENABLE_ANALYTICS: true,
  
  // Custom dimensions and metrics
  CUSTOM_DIMENSIONS: {
    USER_TYPE: 'custom_user_type',
    PAGE_CATEGORY: 'custom_page_category',
    CONTENT_TYPE: 'custom_content_type',
  },
  
  // Event names
  EVENTS: {
    PAGE_VIEW: 'page_view',
    BUTTON_CLICK: 'button_click',
    FORM_SUBMIT: 'form_submit',
    SCROLL_DEPTH: 'scroll_depth',
    TIME_ON_PAGE: 'time_on_page',
    EXTERNAL_LINK: 'external_link',
    DOWNLOAD: 'file_download',
    VIDEO_PLAY: 'video_play',
    SEARCH: 'search',
    CONTACT: 'contact',
  },
  
  // Page categories
  PAGE_CATEGORIES: {
    HOME: 'home',
    BLOG: 'blog',
    SERVICES: 'services',
    ABOUT: 'about',
    CONTACT: 'contact',
    CASE_STUDIES: 'case_studies',
    CAREERS: 'careers',
  },
  
  // Content types
  CONTENT_TYPES: {
    ARTICLE: 'article',
    SERVICE_PAGE: 'service_page',
    LANDING_PAGE: 'landing_page',
    CONTACT_FORM: 'contact_form',
    BLOG_POST: 'blog_post',
  },
};

// GA4 Event Parameters Interface
export interface GA4EventParams {
  [key: string]: string | number | boolean;
}

// Page View Event Interface
export interface PageViewEvent {
  page_title: string;
  page_location: string;
  page_category?: string;
  content_type?: string;
  user_type?: string;
}

// Custom Event Interface
export interface CustomEvent {
  event_name: string;
  event_category: string;
  event_action: string;
  event_label?: string;
  value?: number;
  custom_parameters?: GA4EventParams;
}
